import axios from "axios";
import TraderDTO from "@/models/TraderDTO";
import AccessTokenDTO from "@/models/AccessTokenDTO";
import AccountDTO from "@/models/AccountDTO";
import AccountOperationDTO from "@/models/AccountOperationDTO";
import PaginationDTO from "@/models/PaginationDTO";
import PaginatedResponseDTO from "@/models/PaginatedResponseDTO";
import qs from 'qs';
import TraderDealDTO from "@/models/TraderDealDTO";
import ClientCardDTO from "@/models/ClientCardDTO";
import DealRequestDTO from "@/models/request/DealRequestDTO";
import RequisitesRequestDTO from "@/models/request/RequisitesRequestDTO";
import BulkToggleRequisitesResponseDTO from "@/models/BulkToggleRequisitesResponseDTO";
import BulkUpdateRequisitesResponseDTO from "@/models/BulkUpdateRequisitesResponseDTO";
import {ReuseMinCapsDTO} from "@/models/ReuseMinCapsDTO";
import RequisitesPhoneGroupDTO from "@/models/RequisitesPhoneGroupDTO";
import TraderRequisitesDTO from "@/models/TraderRequisitesDTO";
import PaymentMethodsDTO from "@/models/PaymentMethodsDTO";
import RequisitesUpdateRequestDTO from "@/models/request/RequisitesUpdateRequestDTO";
import UserDTO from "@/models/UserDTO";
import ExtendedDealDTO from "@/models/ExtendedDealDTO";
import MerchantDTO from "@/models/MerchantDTO";
import MerchantIpWhitelistEntryDTO from "@/models/MerchantIpWhitelistEntryDTO";
import InvoiceDTO from "@/models/InvoiceDTO";
import InvoiceDealsRequestDTO from "@/models/request/InvoiceDealsRequestDTO";
import InvoiceDealDTO from "@/models/InvoiceDealDTO";
import TraderDeviceDTO from "@/models/TraderDeviceDTO";
import MerchantStoreDTO from "@/models/MerchantStoreDTO";
import MerchantStoreUpdateRequestDTO from "@/models/request/MerchantStoreUpdateRequestDTO";
import WalletDTO from "@/models/WalletDTO";
import TraderAccountDTO from "@/models/TraderAccountDTO";
import MerchantStoreAccountDTO from "@/models/MerchantStoreAccountDTO";
import TradersUpdateRequestDTO from "@/models/request/TradersUpdateRequestDTO";
import TradersCreateRequestDTO from "@/models/request/TradersCreateRequestDTO";
import UserUpdateRequestDTO from "@/models/request/UserUpdateRequestDTO";
import UserCreateRequestDTO from "@/models/request/UserCreateRequestDTO";
import MerchantUpdateRequestDTO from "@/models/request/MerchantUpdateRequestDTO";
import MerchantCreateRequestDTO from "@/models/request/MerchantCreateRequestDTO";
import AccountWithdrawalRequestDTO from "@/models/request/AccountWithdrawalRequestDTO";
import WithdrawalDTO from "@/models/WithdrawalDTO";
import InviteRequestDTO from "@/models/InviteRequestDTO";
import InviteRequestUserRequestDTO from "@/models/request/InviteRequestUserRequestDTO";
import TraderRequisiteGroupDTO from "@/models/TraderRequisiteGroupDTO";
import PaymentInstructionDTO from "@/models/PaymentInstructionDTO";
import TelegramCreateInviteResponseDTO from "@/models/TelegramCreateInviteResponseDTO";
import AccountTransferRequestDTO from "@/models/request/AccountTransferRequestDTO";
import TelegramMeDTO from "@/models/TelegramMeDTO";
import TraderDealsStatsDTO from "@/models/TraderDealsStatsDTO";
import AttachmentDTO from "@/models/AttachmentDTO";
import TraderPayoutMethodDTO from "@/models/TraderPayoutMethodDTO";
import PayoutMethodUpdateRequestDTO from "@/models/request/PayoutMethodUpdateRequestDTO";
import TwoFactorAuthEnableResponseDTO from "@/models/TwoFactorAuthEnableResponseDTO";
import PaymentOptionsDTO from "@/models/PaymentOptionsDTO";
import UserAccountDTO from "@/models/UserAccountDTO";
import SummaryStatsDTO from "@/models/SummaryStatsDTO";
import TurnoverSummaryResponseDTO from "@/models/TurnoverSummaryDTO";
import ProviderRequestsSummaryItemDTO from "@/models/ProviderRequestsSummaryItemDTO";
import IssuanceTimeStatItemDTO from "@/models/IssuanceTimeStatItemDTO";
import CascadeRatingSnapshotDTO from "@/models/CascadeRatingSnapshotDTO";
import {Direction} from "@/models/enum/Direction";
import DealHistoryDTO from "@/models/DealHistoryDTO";
import TraderRewardSettingsDTO from "@/models/TraderRewardSettingsDTO";
import AntiFraudAlertDTO from "@/models/AntiFraudAlertDTO";
import AntiFraudMerchantBanDTO from "@/models/AntiFraudMerchantBanDTO";
import {DealStatus} from "@/models/enum/DealStatus";
import FrontendAppDTO from "@/models/FrontendAppDTO";
import MerchantOperatorDTO from "@/models/MerchantOperatorDTO";
import MerchantOperatorCreateRequestDTO from "@/models/request/MerchantOperatorCreateRequestDTO";
import MerchantOperatorUpdateRequestDTO from "@/models/request/MerchantOperatorUpdateRequestDTO";
import WithdrawalWhitelistDTO from "@/models/WithdrawalWhitelistDTO";
import MoneyDTO from "@/models/MoneyDTO";
import RequisitesActionHistoryDTO from "@/models/RequisitesActionHistoryDTO";
import {trafficGroups} from "@/service/api/trafficGroups";
import {internalTransferRequests} from "@/service/api/internalTransferRequests";
import {teamLeadRewardSettings} from "@/service/api/teamLeadRewardSettings";
import {traderRewardSettings} from "@/service/api/traderRewardSettings";
import {deposits} from "@/service/api/deposits";
import {traderManualPriorities} from "@/service/api/traderManualPriorities";
import {statistic} from "@/service/api/statistic";
import {BlockReason} from "@/models/enum/BlockReason";
import TraderPayoutSettingsDTO from "@/models/TraderPayoutSettingsDTO";
import TraderPayoutLimitDTO from "@/models/TraderPayoutLimitDTO";
import TraderAntiFraudSettingsDTO from "@/models/TraderAntiFraudSettingsDTO";
import OrderByDTO from "@/models/OrderByDTO";
import {userPermissions} from "@/service/api/userPermissions";
import AutoWithdrawalUpdateRequestDTO from "@/models/request/AutoWithdrawalUpdateRequestDTO";
import {additionalRewardSettings} from "@/service/api/additionalRewardSettings";
import SystemSettingsDTO from "@/models/SystemSettingsDTO";
import SystemSettingsUpdateRequestDTO from "@/models/request/SystemSettingsUpdateRequestDTO";
import TraderDeviceStatusDTO from "@/models/TraderDeviceStatusDTO";
import {providers} from "@/service/api/providers";
import {cascades} from "@/service/api/cascades";
import {traderOperators} from "@/service/api/traderOperators";
import {traderDeals} from "@/service/api/traderDeals";
import {traderRatesBulk} from "@/service/api/traderRatesBulk";
import {traderPayoutPlans} from "@/service/api/traderPayoutPlans";
import WalletsRequestDTO from "@/models/request/WalletsRequestDTO";
import WebhookDTO from "@/models/WebhookDTO";
import TraderRequisitesSettingDTO from "@/models/TraderRequisitesSettingDTO";
import TraderPlanDTO from "@/models/TraderPlanDTO";
import TraderRequisitesSettingCreateRequestDTO from "@/models/request/TraderRequisitesSettingCreateRequestDTO";
import TraderRequisitesSettingUpdateRequestDTO from "@/models/request/TraderRequisitesSettingUpdateRequestDTO";
import TraderRequisitesSettingToggleRequestDTO from "@/models/request/TraderRequisitesSettingToggleRequestDTO";
import CurrencyRateDTO from "@/models/CurrencyRateDTO";
import RequisiteGroupUpdateRequestDTO from "@/models/request/RequisiteGroupUpdateRequestDTO";
import RequisiteTemplateDTO from "@/models/RequisiteTemplateDTO";
import RequisiteTemplateRequestDTO from "@/models/request/RequisiteTemplateRequestDTO";
import PaymentInstructionRequestDTO from "@/models/request/PaymentInstructionRequestDTO";
import PaymentPageLayoutDTO from "@/models/PaymentPageLayoutDTO";
import CounterpartyStatisticsDTO from "@/models/CounterpartyStatisticsDTO";
import CounterpartyImportResultDTO from "@/models/CounterpartyImportResultDTO";
import RequisiteCounterpartyBanRequestDTO from "@/models/RequisiteCounterpartyBanRequestDTO";
import FraudexCheckResponseDTO from "@/models/FraudexCheckResponseDTO";
import TelegramBroadcastAudienceDTO from "@/models/TelegramBroadcastAudienceDTO";
import TelegramBroadcastAudienceSpec from "@/models/TelegramBroadcastAudienceSpec";
import TelegramBroadcastMerchantGroupDTO from "@/models/TelegramBroadcastMerchantGroupDTO";
import TelegramBroadcastJournalItemDTO from "@/models/TelegramBroadcastJournalItemDTO";
import RateSourceDTO from "@/models/RateSourceDTO";
import BulkRequisitesUploadRequestDTO from "@/models/request/BulkRequisitesUploadRequestDTO";
import SettingsHistoryItemDTO from "@/models/SettingsHistoryItemDTO";
import StoreSettingsHistoryItemDTO from "@/models/StoreSettingsHistoryItemDTO";
import PendingPaymentRequestsCountDTO from "@/models/PendingPaymentRequestsCountDTO";
import {exportTasks} from "@/service/api/exportTasks";
import {referrals} from "@/service/api/referrals";

const parseContentDispositionFilename = (header: string|undefined|null): string|null => {
    if (!header) {
        return null;
    }

    // RFC 5987: filename*=UTF-8''%D0%A1%D1%82%D0%B0... — used for non-ASCII names
    const extended = /filename\*\s*=\s*([^']*)'([^']*)'([^;]+)/i.exec(header);
    if (extended) {
        try {
            return decodeURIComponent(extended[3].trim().replace(/^"|"$/g, ''));
        } catch (e) {
            // malformed encoding — fall through to the plain filename
        }
    }

    const plain = /filename\s*=\s*"?([^";]+)"?/i.exec(header);
    if (plain) {
        return plain[1].trim();
    }

    return null;
}

export default class APIClient {

    baseUrl = () => {
        return axios.defaults.baseURL;
    }

    call =  {
        userPermissions,
        trafficGroups,
        internalTransferRequests,
        teamLeadRewardSettings,
        traderRewardSettings,
        deposits,
        traderManualPriorities,
        additionalRewardSettings,
        statistic,
        providers,
        cascades,
        traderOperators,
        traderPayoutPlans,
        exportTasks,
        referrals,
        traderDeals,
        traderRatesBulk
    }

    me = async (): Promise<UserDTO|TraderDTO|MerchantDTO|MerchantOperatorDTO> => {
        let resp = await axios({
            url: `/users/me`,
            method: 'GET',
        });

        return resp.data;
    }

    ping = async (baseURL: string): Promise<any> => {
        let resp = await axios({
            baseURL,
            url: `/ping`,
            method: 'GET',
        });

        return resp.data;
    }

    getInviteRequest = async (token: string): Promise<InviteRequestDTO> => {
        let resp = await axios({
            url: `/invite-requests/${token}`,
            method: 'GET',
        });

        return resp.data;
    }

    useInviteRequest = async (token: string, req: InviteRequestUserRequestDTO): Promise<AccessTokenDTO> => {
        let resp = await axios({
            url: `/invite-requests/${token}/use`,
            data: {
                ...req
            },
            method: 'POST',
        });

        return resp.data;
    }

    changeMeStatus = async (isActive: boolean, direction: Direction): Promise<any> => {
        return axios({
            url: `/traders/me/change-status`,
            method: 'PUT',
            data: {
                isActive,
                direction
            },
        });
    }

    changeMeConcurrentDealsLimit = async (isConcurrentDealsLimitEnabled: boolean, concurrentDealsLimit: number|null): Promise<void> => {
        await axios({
            url: `/traders/me/concurrent-deals-limit`,
            method: 'PUT',
            data: {
                isConcurrentDealsLimitEnabled,
                concurrentDealsLimit
            },
        });
    }

    changeTraderStatus = async (id: number, isActive: boolean, direction: Direction): Promise<TraderDTO> => {
        return (await axios({
            url: `/traders/${id}/change-status`,
            method: 'PUT',
            data: {
                isActive,
                direction
            },
        })).data as TraderDTO;
    }

    blockTrader = async (id: number, isBlocked: boolean, blockReason: BlockReason|null): Promise<TraderDTO> => {
        return (await axios({
            url: `/traders/${id}/toggle-block`,
            method: 'PUT',
            data: {
                isBlocked,
                blockReason
            },
        })).data as TraderDTO;
    }

    setTraderPayOutDisputeReminderToGroupChat = async (id: number, isEnabled: boolean): Promise<TraderDTO> => {
        return (await axios({
            url: `/traders/${id}/pay-out-dispute-reminder-group-chat`,
            method: 'PUT',
            data: {
                isEnabled,
            },
        })).data as TraderDTO;
    }

    trader2faDisable = async (id: number): Promise<void> => {
        (await axios({
            url: `/traders/${id}/2fa/disable`,
            method: 'PUT',
        })).data
    }

    user2faDisable = async (id: number): Promise<void> => {
        (await axios({
            url: `/users/${id}/2fa/disable`,
            method: 'PUT',
        })).data
    }

    usersChangePassword = async (id: number, plainPassword: string): Promise<void> => {
        (await axios({
            url: `/users/${id}/password`,
            method: 'PUT',
            data: {plainPassword},
        })).data
    }

    merchantOperatorChangePassword = async (id: number, plainPassword: string): Promise<void> => {
        (await axios({
            url: `/merchant-operators/${id}/password`,
            method: 'PUT',
            data: {plainPassword},
        })).data
    }

    traderRewardSettings = async (): Promise<TraderRewardSettingsDTO[]> => {
        return (await axios({
            url: `/traders/me/traffic-groups/reward-settings`,
            method: 'GET',
        })).data as TraderRewardSettingsDTO[];
    }

    traderCurrencyRatesByGroupsSettings = async (): Promise<any[]> => {
        return (await axios({
            url: `/traders/currency-rates-by-traffic-groups`,
            method: 'GET',
        })).data as any[];
    }

    traderPayoutLimit = async (): Promise<TraderPayoutLimitDTO | null> => {
        return (await axios({
            url: `/trader-payout-limit`,
            method: 'GET',
        })).data as TraderPayoutLimitDTO | null;
    }

    traderPayoutSettings = async (): Promise<TraderPayoutSettingsDTO> => {
        return (await axios({
            url: `/trader-payout-settings`,
            method: 'GET',
        })).data as TraderPayoutSettingsDTO;
    }

    traderPayoutSettingsById = async (id: number): Promise<TraderPayoutSettingsDTO> => {
        return (await axios({
            url: `/trader-payout-settings/${id}`,
            method: 'GET',
        })).data as TraderPayoutSettingsDTO;
    }

    traderPayoutSettingsUpdate = async (item: TraderPayoutSettingsDTO): Promise<TraderPayoutSettingsDTO> => {
        return (await axios({
            url: `/trader-payout-settings`,
            data: {
                ...item,
                minAmount: item.minAmount ? item.minAmount : null,
                maxAmount: item.maxAmount ? item.maxAmount : null,
            },
            method: 'PUT',
        })).data as TraderPayoutSettingsDTO;
    }

    traderPayoutSettingsUpdateById = async (traderId: number, item: TraderPayoutSettingsDTO): Promise<TraderPayoutSettingsDTO> => {
        return (await axios({
            url: `/trader-payout-settings/${traderId}`,
            data: {
                ...item,
                minAmount: item.minAmount ? item.minAmount : null,
                maxAmount: item.maxAmount ? item.maxAmount : null,
            },
            method: 'PUT',
        })).data as TraderPayoutSettingsDTO;
    }

    traderPayoutSettingsResetBalance = async (traderId: number, currency: string): Promise<TraderPayoutSettingsDTO> => {
        return (await axios({
            url: `/trader-payout-settings/${traderId}/reset-balance`,
            params: { currency },
            method: 'POST',
        })).data as TraderPayoutSettingsDTO;
    }

    traderAntiFraudSettingsById = async (id: number): Promise<TraderAntiFraudSettingsDTO> => {
        return (await axios({
            url: `/trader-anti-fraud-settings/${id}`,
            method: 'GET',
        })).data as TraderAntiFraudSettingsDTO;
    }

    traderAntiFraudSettingsUpdateById = async (traderId: number, item: Omit<TraderAntiFraudSettingsDTO, 'payOutFakeReceiptsCount'>): Promise<TraderAntiFraudSettingsDTO> => {
        return (await axios({
            url: `/trader-anti-fraud-settings/${traderId}`,
            data: {
                payInCanceledCount: item.payInCanceledCount !== null && item.payInCanceledCount !== undefined ? item.payInCanceledCount : null,
                activeDisputesThreshold: item.activeDisputesThreshold != null && item.activeDisputesThreshold >= 1 ? item.activeDisputesThreshold : null,
                payOutFakeReceiptsLimit: item.payOutFakeReceiptsLimit != null && item.payOutFakeReceiptsLimit >= 0 ? item.payOutFakeReceiptsLimit : null,
            },
            method: 'PUT',
        })).data as TraderAntiFraudSettingsDTO;
    }

    updateProfile = async (profile: any): Promise<any> => {
        return axios({
            url: `/users/profile`,
            method: 'PUT',
            data: {
                ...profile
            },
        });
    }

    devicesDownload = async (id: string): Promise<any> => {
        let resp = await axios({
            url: `/trader-devices/${id}/macrodroid`,
            method: 'GET',
        });

        return resp.data;
    }

    devicesRegisterDevice = async (id: string, version: string): Promise<any> => {
        let resp = await axios({
            url: `/trader-devices/${id}/register-device?version=${version}`,
            method: 'GET',
        });

        return resp.data;
    }

    deviceAppDownload = async (id: any): Promise<any> => {
        let resp = await axios({
            url: `/trader-devices/android-apps/${id}/download`,
            method: 'GET',
            responseType: 'blob',
        });

        return resp.data;
    }

    bankAppsLink = async (): Promise<string> => {
        let resp = await axios({
            url: `/trader-devices/bank-apps-external-link`,
            method: 'GET',
        });

        return resp.data as string;
    }

    manualLink = async (): Promise<string> => {
        let resp = await axios({
            url: `/traders/manual-link`,
            method: 'GET',
        });

        return resp.data as string;
    }

    currencyRates = async (): Promise<any[]> => {
        let resp = await axios({
            url: `/traders/currency-rates`,
            method: 'GET',
        });

        return resp.data as any[];
    }

    currencyRatesOperatorAndAdmin = async (pagination: PaginationDTO, search: string = ''): Promise<PaginatedResponseDTO<CurrencyRateDTO>> => {
        let resp = await axios({
            url: `/currency-rates`,
            method: 'GET',
            params: {
                limit: pagination.limit,
                offset: pagination.offset,
                search,
            },
            paramsSerializer: params => {
                return qs.stringify(params)
            }
        });

        return resp.data as PaginatedResponseDTO<CurrencyRateDTO>;
    }

    currencyRatesCreate = async (data: any): Promise<CurrencyRateDTO> => {
        let resp = await axios({
            url: `/currency-rates`,
            method: 'POST',
            data
        });

        return resp.data as CurrencyRateDTO;
    }

    currencyRatesUpdate = async (id: number, data: any): Promise<CurrencyRateDTO> => {
        let resp = await axios({
            url: `/currency-rates/${id}`,
            method: 'PUT',
            data
        });

        return resp.data as CurrencyRateDTO;
    }

    currencyRatesDelete = async (id: number): Promise<void> => {
        let resp = await axios({
            url: `/currency-rates/${id}`,
            method: 'DELETE'
        });
    }

    currencyRatesAll = async (): Promise<CurrencyRateDTO[]> => {
        let resp = await axios({
            url: `/currency-rates/all`,
            method: 'GET',
        });

        return resp.data as CurrencyRateDTO[];
    }

    devicesListApps = async (): Promise<any> => {
        let resp = await axios({
            url: `/trader-devices/android-apps`,
            method: 'GET',
        });

        return resp.data;
    }

    createTgInviteRequest = async (): Promise<TelegramCreateInviteResponseDTO> => {
        let resp = await axios({
            url: `/telegram/invite-requests`,
            method: 'POST',
        });

        return resp.data as TelegramCreateInviteResponseDTO;
    }

    getTgMe = async (): Promise<TelegramMeDTO> => {
        let resp = await axios({
            url: `/telegram/me`,
            method: 'GET',
        });

        return resp.data as TelegramMeDTO;
    }

    twoFactorAuthDisable = async (): Promise<void> => {
        await axios({
            url: `/2fa/disable`,
            method: 'POST',
        });
    }

    twoFactorAuthEnable = async (): Promise<TwoFactorAuthEnableResponseDTO> => {
        let resp = await axios({
            url: `/2fa/enable`,
            method: 'POST',
        });

        return resp.data as TwoFactorAuthEnableResponseDTO;
    }

    twoFactorAuthEnableConfirm = async (data: TwoFactorAuthEnableResponseDTO): Promise<void> => {
        await axios({
            url: `/2fa/enable-confirm`,
            method: 'POST',
            data
        });
    }

    deleteTgMe = async (): Promise<TelegramMeDTO> => {
        let resp = await axios({
            url: `/telegram/me`,
            method: 'DELETE',
        });

        return resp.data as TelegramMeDTO;
    }

    updateTgNotifications = async (requestDTO: any): Promise<TelegramMeDTO> => {
        let resp = await axios({
            url: `/telegram/me/notifications`,
            method: 'PUT',
            data: {
                ...requestDTO
            }
        });

        return resp.data as TelegramMeDTO;
    }

    devicesMessageLogs = async (id: string, params: Object): Promise<PaginatedResponseDTO<any>> => {
        let resp = await axios({
            url: `/trader-devices/${id}/message-log`,
            method: 'GET',
            params: params,
            paramsSerializer: params => {
                return qs.stringify(params)
            }
        });

        return resp.data;
    }

    storeGet = async (id: number): Promise<MerchantStoreDTO> => {
        let resp = await axios({
            url: `/stores/${id}`,
            method: 'GET',
        });

        return resp.data as MerchantStoreDTO;
    }


    storesAll = async (): Promise<MerchantStoreDTO[]> => {
        let resp = await axios({
            url: `/stores/all`,
            method: 'GET',
        });

        return resp.data as MerchantStoreDTO[];
    }

    updateStoreApiKey = async (id: number): Promise<MerchantStoreDTO> => {
        let resp = await axios({
            url: `/stores/${id}/api-key`,
            method: 'PUT',
        })
        return resp.data as MerchantStoreDTO
    }

    deleteStore = async (id: number): Promise<void> => {
        let resp = await axios({
            url: `/stores/${id}`,
            method: 'DELETE',
        })
    }

    updateStore = async (id: number, requestDTO: MerchantStoreUpdateRequestDTO): Promise<MerchantStoreDTO> => {
        let resp = await axios({
            url: `/stores/${id}`,
            data: requestDTO,
            method: 'PUT',
        })
        return resp.data as MerchantStoreDTO
    }

    createStore = async (requestDTO: MerchantStoreUpdateRequestDTO): Promise<MerchantStoreDTO> => {
        let resp = await axios({
            url: `/stores`,
            data: requestDTO,
            method: 'POST',
        })
        return resp.data as MerchantStoreDTO
    }


    devicesAll = async (): Promise<TraderDeviceDTO[]> => {
        let resp = await axios({
            url: `/trader-devices/all`,
            method: 'GET',
        });

        return resp.data as TraderDeviceDTO[];
    }

    traderRequisiteGroupsAll = async (): Promise<TraderRequisiteGroupDTO[]> => {
        let resp = await axios({
            url: `/trader-requisite-groups/all`,
            method: 'GET',
        });

        return resp.data as TraderRequisiteGroupDTO[];
    }

    traderRequisiteGroups = async (pagination: PaginationDTO, req: Object = {}): Promise<PaginatedResponseDTO<TraderRequisiteGroupDTO>> => {
        let resp = await axios({
            url: `/trader-requisite-groups`,
            method: 'POST',
            headers: {'X-HTTP-METHOD-OVERRIDE': "GET"},
            data: {
                limit: pagination.limit,
                offset: pagination.offset,
                ...req
            }
        });

        return resp.data as PaginatedResponseDTO<TraderRequisiteGroupDTO>;
    }

    traderDevices = async (pagination: PaginationDTO, req: Object = {}): Promise<PaginatedResponseDTO<TraderDeviceDTO>> => {
        let resp = await axios({
            url: `/trader-devices`,
            method: 'POST',
            headers: {'X-HTTP-METHOD-OVERRIDE': "GET"},
            data: {
                limit: pagination.limit,
                offset: pagination.offset,
                ...req
            }
        });

        return resp.data as PaginatedResponseDTO<TraderDeviceDTO>;
    }

    devicesCreate = async (device: TraderDeviceDTO): Promise<TraderDeviceDTO> => {
        let resp = await axios({
            url: `/trader-devices`,
            data: device,
            method: 'POST',
        });

        return resp.data as TraderDeviceDTO
    }

    devicesGet = async (id: string): Promise<TraderDeviceDTO> => {
        let resp = await axios({
            url: `/trader-devices/${id}`,
            method: 'GET',
        });

        return resp.data as TraderDeviceDTO
    }

    devicesUpdate = async (id: string, device: TraderDeviceDTO): Promise<TraderDeviceDTO> => {
        let resp = await axios({
            url: `/trader-devices/` + id,
            data: device,
            method: 'PUT',
        });

        return resp.data as TraderDeviceDTO
    }

    devicesDelete = async (id: string): Promise<void> => {
        let resp = await axios({
            url: `/trader-devices/` + id,
            method: 'DELETE',
        });
    }

    devicesChangeStatus = async (id: string, status: TraderDeviceStatusDTO): Promise<void> => {
        let resp = await axios({
            url: `/trader-devices/` + id + `/change-status`,
            data: status,
            method: 'PUT',
        });
    }

    devicesIgnoreOfflineNotifications = async (id: string, status: string): Promise<void> => {
        let resp = await axios({
            url: `/trader-devices/` + id + `/ignore-notifications-status/` + status,
            data: status,
            method: 'PUT',
        });
    }

    traderRequisiteGroupDelete = async (id: number): Promise<void> => {
        let resp = await axios({
            url: `/trader-requisite-groups/` + id,
            method: 'DELETE',
        });
    }

    traderRequisiteGroupToggleRequisites = async (id: number, mode: string): Promise<TraderRequisiteGroupDTO> => {
        let resp = await axios({
            url: `/trader-requisite-groups/${id}/requisites/${mode}`,
            method: 'POST',
        });

        return resp.data as TraderRequisiteGroupDTO
    }

    traderRequisiteGroupUpdate = async (id: number, group: RequisiteGroupUpdateRequestDTO): Promise<TraderRequisiteGroupDTO> => {
        let resp = await axios({
            url: `/trader-requisite-groups/` + id,
            data: group,
            method: 'PUT',
        });

        return resp.data as TraderRequisiteGroupDTO
    }

    traderRequisiteGroupCreate = async (device: RequisiteGroupUpdateRequestDTO): Promise<TraderRequisiteGroupDTO> => {
        let resp = await axios({
            url: `/trader-requisite-groups`,
            data: device,
            method: 'POST',
        });

        return resp.data as TraderRequisiteGroupDTO
    }

    requisiteTemplatesAll = async (): Promise<RequisiteTemplateDTO[]> => {
        let resp = await axios({
            url: `/requisite-templates/all`,
            method: 'GET',
        });

        return resp.data as RequisiteTemplateDTO[];
    }

    requisiteTemplates = async (pagination: PaginationDTO, req: Object = {}): Promise<PaginatedResponseDTO<RequisiteTemplateDTO>> => {
        let resp = await axios({
            url: `/requisite-templates`,
            method: 'POST',
            headers: {'X-HTTP-METHOD-OVERRIDE': "GET"},
            data: {
                limit: pagination.limit,
                offset: pagination.offset,
                ...req
            }
        });

        return resp.data as PaginatedResponseDTO<RequisiteTemplateDTO>;
    }

    requisiteTemplateCreate = async (template: RequisiteTemplateRequestDTO): Promise<RequisiteTemplateDTO> => {
        let resp = await axios({
            url: `/requisite-templates`,
            data: template,
            method: 'POST',
        });

        return resp.data as RequisiteTemplateDTO
    }

    requisiteTemplateUpdate = async (id: number, template: RequisiteTemplateRequestDTO): Promise<RequisiteTemplateDTO> => {
        let resp = await axios({
            url: `/requisite-templates/` + id,
            data: template,
            method: 'PUT',
        });

        return resp.data as RequisiteTemplateDTO
    }

    requisiteTemplateDelete = async (id: number): Promise<void> => {
        await axios({
            url: `/requisite-templates/` + id,
            method: 'DELETE',
        });
    }

    accountsAll = async (): Promise<AccountDTO[]> => {
        let resp = await axios({
            url: `/accounts/all`,
            method: 'GET',
        });

        return resp.data as AccountDTO[];
    }

    accountsGet = async (id: string): Promise<AccountDTO> => {
        let resp = await axios({
            url: `/accounts/${id}`,
            method: 'GET',
        });

        return resp.data as AccountDTO;
    }

    traderAccountsSummary = async (req: { onlyWithOperators?: boolean | string } = {}): Promise<AccountDTO[]> => {
        const processedReq = { ...req };
        if (processedReq.onlyWithOperators !== undefined) {
            processedReq.onlyWithOperators = processedReq.onlyWithOperators === true || processedReq.onlyWithOperators === 'true' ? 'y' : 'n';
        }
        
        let resp = await axios({
            url: `/trader-accounts/summary`,
            method: 'GET',
            params: {
                ...processedReq
            },
            paramsSerializer: params => {
                return qs.stringify(params)
            }
        });

        return resp.data as AccountDTO[];
    }

    merchantStoreAccountsSummary = async (): Promise<AccountDTO[]> => {
        let resp = await axios({
            url: `/merchant-store-accounts/summary`,
            method: 'GET',
            paramsSerializer: params => {
                return qs.stringify(params)
            }
        });

        return resp.data as AccountDTO[];
    }

    systemAccountsSummary = async (): Promise<AccountDTO[]> => {
        let resp = await axios({
            url: `/system-accounts/summary`,
            method: 'GET',
            paramsSerializer: params => {
                return qs.stringify(params)
            }
        });

        return resp.data as AccountDTO[];
    }

    userAccountsSummary = async (req: Object = {}): Promise<AccountDTO[]> => {
        let resp = await axios({
            url: `/user-accounts/summary`,
            method: 'POST',
            headers: {'X-HTTP-METHOD-OVERRIDE': "GET"},
            data: {
                ...req
            }
        });

        return resp.data as AccountDTO[];
    }

    traderAccounts = async (pagination: PaginationDTO, req: Object = {}): Promise<PaginatedResponseDTO<TraderAccountDTO>> => {
        let resp = await axios({
            url: `/trader-accounts`,
            method: 'POST',
            headers: {'X-HTTP-METHOD-OVERRIDE': "GET"},
            data: {
                limit: pagination.limit,
                offset: pagination.offset,
                ...req
            }
        });

        return resp.data as PaginatedResponseDTO<TraderAccountDTO>;
    }

    userAccounts = async (pagination: PaginationDTO, req: Object = {}): Promise<PaginatedResponseDTO<UserAccountDTO>> => {
        let resp = await axios({
            url: `/user-accounts`,
            method: 'POST',
            headers: {'X-HTTP-METHOD-OVERRIDE': "GET"},
            data: {
                limit: pagination.limit,
                offset: pagination.offset,
                ...req
            }
        });

        return resp.data as PaginatedResponseDTO<UserAccountDTO>;
    }

    traders = async (pagination: PaginationDTO, req: Object = {}, orderByDTO: OrderByDTO = {field: "id", direction: "asc"}): Promise<PaginatedResponseDTO<TraderDTO>> => {
        let orderBy = {} as any
        if (orderByDTO.field) {
            orderBy[orderByDTO.field] = orderByDTO.direction
        }
        let resp = await axios({
            url: `/traders`,
            method: 'GET',
            params: {
                limit: pagination.limit,
                offset: pagination.offset,
                orderBy: orderBy,
                ...req,
            },
            paramsSerializer: params => {
                return qs.stringify(params)
            }
        });

        return resp.data as PaginatedResponseDTO<TraderDTO>;
    }

    merchants = async (pagination: PaginationDTO, req: Object = {}): Promise<PaginatedResponseDTO<MerchantDTO>> => {
        let resp = await axios({
            url: `/merchants`,
            method: 'POST',
            headers: {'X-HTTP-METHOD-OVERRIDE': "GET"},
            data: {
                limit: pagination.limit,
                offset: pagination.offset,
                ...req
            }
        });

        return resp.data as PaginatedResponseDTO<MerchantDTO>;
    }

    merchantStores = async (pagination: PaginationDTO, req: Object = {}): Promise<PaginatedResponseDTO<MerchantStoreDTO>> => {
        let resp = await axios({
            url: `/stores`,
            method: 'GET',
            params: {
                limit: pagination.limit,
                offset: pagination.offset,
                ...req
            },
            paramsSerializer: params => {
                return qs.stringify(params)
            }
        });

        return resp.data as PaginatedResponseDTO<MerchantStoreDTO>;
    }


    withdrawalWhitelistDelete = async (id: number): Promise<WithdrawalWhitelistDTO> => {
        let resp = await axios({
            url: `/withdrawal-whitelists/${id}`,
            method: 'DELETE'
        });

        return resp.data as WithdrawalWhitelistDTO;
    }

    withdrawalWhitelistCreate = async (item: WithdrawalWhitelistDTO): Promise<WithdrawalWhitelistDTO> => {
        let resp = await axios({
            url: `/withdrawal-whitelists`,
            method: 'POST',
            data: {
                ...item
            }
        });

        return resp.data as WithdrawalWhitelistDTO;
    }

    withdrawalWhitelist = async (pagination: PaginationDTO, req: any = {}): Promise<PaginatedResponseDTO<WithdrawalWhitelistDTO>> => {
        let resp = await axios({
            url: `/withdrawal-whitelists`,
            method: 'GET',
            params: {
                limit: pagination.limit,
                offset: pagination.offset,
                ...req
            },
            paramsSerializer: params => {
                return qs.stringify(params)
            }
        });

        return resp.data as PaginatedResponseDTO<WithdrawalWhitelistDTO>;
    }

    merchantsStoresAll = async (merchantId: number): Promise<MerchantStoreDTO[]> => {
        let resp = await axios({
            url: `/merchants/${merchantId}/stores/all`,
            method: 'GET',
            paramsSerializer: params => {
                return qs.stringify(params)
            }
        });

        return resp.data as MerchantStoreDTO[];
    }

    merchantIpWhitelistList = async (merchantId: number): Promise<MerchantIpWhitelistEntryDTO[]> => {
        let resp = await axios({
            url: `/merchants/${merchantId}/ip-whitelist`,
            method: 'GET',
        });

        return resp.data as MerchantIpWhitelistEntryDTO[];
    }

    merchantIpWhitelistCreate = async (merchantId: number, body: { ip: string }): Promise<MerchantIpWhitelistEntryDTO> => {
        let resp = await axios({
            url: `/merchants/${merchantId}/ip-whitelist`,
            method: 'POST',
            data: body,
        });

        return resp.data as MerchantIpWhitelistEntryDTO;
    }

    merchantIpWhitelistDelete = async (merchantId: number, ipId: number): Promise<void> => {
        await axios({
            url: `/merchants/${merchantId}/ip-whitelist/${ipId}`,
            method: 'DELETE',
        });
    }

    users = async (pagination: PaginationDTO, request: any): Promise<PaginatedResponseDTO<UserDTO>> => {
        let resp = await axios({
            url: `/users`,
            method: 'GET',
            params: {
                limit: pagination.limit,
                offset: pagination.offset,
                ...request
            },
            paramsSerializer: params => {
                return qs.stringify(params)
            }
        });

        return resp.data as PaginatedResponseDTO<UserDTO>;
    }

    merchantOperators = async (pagination: PaginationDTO, request: any): Promise<PaginatedResponseDTO<MerchantOperatorDTO>> => {
        let resp = await axios({
            url: `/merchant-operators`,
            method: 'GET',
            params: {
                limit: pagination.limit,
                offset: pagination.offset,
                ...request
            },
            paramsSerializer: params => {
                return qs.stringify(params)
            }
        });

        return resp.data as PaginatedResponseDTO<MerchantOperatorDTO>;
    }

    trEnergyAccount = async (): Promise<any> => {
        let resp = await axios({
            url: `/tr-energy`,
            method: 'GET',
        });

        return resp.data as any;
    }

    walletsSummary = async (): Promise<any> => {
        let resp = await axios({
            url: `/wallets/summary`,
            method: 'GET',
        });

        return resp.data as any;
    }

    energyData = async (): Promise<any> => {
        let resp = await axios({
            url: `/energy`,
            method: 'GET',
        });

        return resp.data as any;
    }

    antiFraudAlertsReviewed = async (id: number): Promise<void> => {
        await axios({
            url: `/anti-fraud-alerts/${id}/reviewed`,
            method: 'PUT',
        });
    }

    antiFraudAlerts = async (pagination: PaginationDTO, requestDTO: any): Promise<PaginatedResponseDTO<AntiFraudAlertDTO>> => {
        let resp = await axios({
            url: `/anti-fraud-alerts`,
            method: 'GET',
            params: {
                limit: pagination.limit,
                offset: pagination.offset,
                ...requestDTO
            },
            paramsSerializer: params => {
                return qs.stringify(params)
            }
        });

        return resp.data as PaginatedResponseDTO<AntiFraudAlertDTO>;
    }

    antiFraudAlertsCount = async (lastId: number|null): Promise<boolean> => {
        let resp = await axios({
            url: `/anti-fraud-alerts/count`,
            method: 'GET',
            params: {
                lastId
            }
        });

        return resp.data as boolean;
    }

    antiFraudMerchantBans = async (pagination: PaginationDTO, requestDTO: any = {}): Promise<PaginatedResponseDTO<AntiFraudMerchantBanDTO>> => {
        let resp = await axios({
            url: `/anti-fraud-merchant`,
            method: 'GET',
            params: {
                limit: pagination.limit,
                offset: pagination.offset,
                ...requestDTO
            },
            paramsSerializer: params => {
                return qs.stringify(params)
            }
        });

        return resp.data as PaginatedResponseDTO<AntiFraudMerchantBanDTO>;
    }

    antiFraudMerchantUnban = async (id: number): Promise<void> => {
        await axios({
            url: `/anti-fraud-merchant/${id}/unban`,
            method: 'POST',
        });
    }

    wallets = async (pagination: PaginationDTO, request: WalletsRequestDTO): Promise<PaginatedResponseDTO<WalletDTO>> => {
        let resp = await axios({
            url: `/wallets`,
            method: 'GET',
            params: {
                limit: pagination.limit,
                offset: pagination.offset,
                ...request,
            },
            paramsSerializer: params => {
                return qs.stringify(params)
            }
        });

        return resp.data as PaginatedResponseDTO<WalletDTO>;
    }

    walletsSystemAll = async (): Promise<WalletDTO[]> => {
        let resp = await axios({
            url: `/wallets/system/all`,
            method: 'GET',
        });

        return resp.data as WalletDTO[];
    }

    merchantStoreAccounts = async (pagination: PaginationDTO, req: Object = {}): Promise<PaginatedResponseDTO<MerchantStoreAccountDTO>> => {
        let resp = await axios({
            url: `/merchant-store-accounts`,
            method: 'POST',
            headers: {'X-HTTP-METHOD-OVERRIDE': "GET"},
            data: {
                limit: pagination.limit,
                offset: pagination.offset,
                ...req
            },
            paramsSerializer: params => {
                return qs.stringify(params)
            }
        });

        return resp.data as PaginatedResponseDTO<MerchantStoreAccountDTO>;
    }

    accountsAutoWithdrawal = async (id: string, requestDTO: AutoWithdrawalUpdateRequestDTO): Promise<AccountDTO> => {
        let resp = await axios({
            url: `/accounts/${id}/auto-withdrawal`,
            method: 'POST',
            data: {
                ...requestDTO
            },
            paramsSerializer: params => {
                return qs.stringify(params)
            }
        });

        return resp.data as AccountDTO;
    }

    invoiceDeal = async (id: string): Promise<InvoiceDealDTO> => {
        let resp = await axios({
            url: `/invoice-deals/${id}`,
            method: 'GET',
        });

        return resp.data as InvoiceDealDTO;
    }

    withdrawal = async (id: string): Promise<WithdrawalDTO> => {
        let resp = await axios({
            url: `/withdrawals/${id}`,
            method: 'GET',
        });

        return resp.data as WithdrawalDTO;
    }

    processWithdrawal = async (id: string): Promise<WithdrawalDTO> => {
        let resp = await axios({
            url: `/withdrawals/${id}/process`,
            method: 'POST',
        });

        return resp.data as WithdrawalDTO;
    }

    cancelWithdrawal = async (id: string): Promise<WithdrawalDTO> => {
        let resp = await axios({
            url: `/withdrawals/${id}/cancel`,
            method: 'POST',
        });

        return resp.data as WithdrawalDTO;
    }

    renewWithdrawal = async (id: string): Promise<WithdrawalDTO> => {
        let resp = await axios({
            url: `/withdrawals/${id}/renew`,
            method: 'POST',
        });

        return resp.data as WithdrawalDTO;
    }

    accountWallet = async (id: string): Promise<WalletDTO> => {
        let resp = await axios({
            url: `/accounts/${id}/wallet`,
            method: 'GET',
        });

        return resp.data as WalletDTO;
    }

    accountWalletCreate = async (id: string): Promise<WalletDTO> => {
        let resp = await axios({
            url: `/accounts/${id}/wallet`,
            method: 'POST',
        });

        return resp.data as WalletDTO;
    }

    accountWithdrawalWhitelistToggle = async (id: string, action: string): Promise<AccountDTO> => {
        let resp = await axios({
            url: `/accounts/${id}/withdrawal-whitelists/${action}`,
            method: 'POST',
        });

        return resp.data as AccountDTO;
    }

    accountsAutoTransfer = async (id: string, requestDTO: any): Promise<any> => {
        let resp = await axios({
            url: `/accounts/${id}/auto-transfer`,
            data: requestDTO,
            method: 'POST',
        });

        return resp.data;
    }

    invoiceDeals = async (pagination: PaginationDTO, orderBy: Object, request: InvoiceDealsRequestDTO): Promise<PaginatedResponseDTO<InvoiceDealDTO>> => {
        let resp = await axios({
            url: `/invoice-deals`,
            method: 'GET',
            params: {
                limit: pagination.limit,
                offset: pagination.offset,
                orderBy: orderBy,
                ...request
            },
            paramsSerializer: params => {
                return qs.stringify(params)
            }
        });

        return resp.data as PaginatedResponseDTO<InvoiceDealDTO>;
    }

    dealsStats = async (request: DealRequestDTO): Promise<TraderDealsStatsDTO[]> => {
        let resp = await axios({
            url: `/trader-deals/stats`,
            method: 'GET',
            params: {
                ...request
            },
            paramsSerializer: params => {
                return qs.stringify(params)
            }
        });

        return resp.data as TraderDealsStatsDTO[];
    }

    export = async (name: string, request: Object): Promise<any> => {
        let resp = await axios({
            url: `/export/${name}`,
            method: 'GET',
            responseType: 'blob',
            params: {
                ...request
            },
            paramsSerializer: params => {
                return qs.stringify(params)
            }
        });

        return resp.data;
    }

    /**
     * Same as export(), but also returns the file name from Content-Disposition.
     * The header is only readable when the backend exposes it via CORS
     * (Access-Control-Expose-Headers), otherwise fallbackFilename is returned.
     */
    exportWithFilename = async (name: string, request: Object, fallbackFilename: string = 'report.xlsx'): Promise<{blob: Blob, filename: string}> => {
        let resp = await axios({
            url: `/export/${name}`,
            method: 'GET',
            responseType: 'blob',
            params: {
                ...request
            },
            paramsSerializer: params => {
                return qs.stringify(params)
            }
        });

        return {
            blob: new Blob([resp.data]),
            filename: parseContentDispositionFilename(resp.headers['content-disposition']) ?? fallbackFilename,
        };
    }

    statisticSummary = async (request: Object): Promise<SummaryStatsDTO[]> => {
        let resp = await axios({
            url: `/statistic/summary`,
            method: 'GET',
            params: {
                ...request
            },
            paramsSerializer: params => {
                return qs.stringify(params)
            }
        });

        return resp.data as SummaryStatsDTO[];
    }

    statisticTurnoverSummary = async (request: Object): Promise<TurnoverSummaryResponseDTO> => {
        let resp = await axios({
            url: `/statistic/turnover-summary`,
            method: 'GET',
            params: {
                ...request
            },
            paramsSerializer: params => {
                return qs.stringify(params)
            }
        });

        return resp.data as TurnoverSummaryResponseDTO;
    }

    statisticOnlineSummaryAmounts = async (request: Object): Promise<any> => {
        let resp = await axios({
            url: `/statistic/online-summary/amounts`,
            method: 'GET',
            params: {
                ...request
            },
            paramsSerializer: params => {
                return qs.stringify(params)
            }
        });

        return resp.data as any;
    }

    statisticOnlineSummary = async (request: Object): Promise<any> => {
        let resp = await axios({
            url: `/statistic/online-summary`,
            method: 'GET',
            params: {
                ...request
            },
            paramsSerializer: params => {
                return qs.stringify(params)
            }
        });

        return resp.data as any;
    }

    statisticOnlineAmounts = async (): Promise<any> => {
        let resp = await axios({
            url: `/statistic/online-amounts`,
            method: 'GET',
            paramsSerializer: params => {
                return qs.stringify(params)
            }
        });

        return resp.data as any;
    }

    statisticProviderRequestsSummary = async (request: Object): Promise<ProviderRequestsSummaryItemDTO[]> => {
        let resp = await axios({
            url: `/statistic/provider-requests-summary`,
            method: 'GET',
            params: {
                ...request
            },
            paramsSerializer: params => {
                return qs.stringify(params)
            }
        });

        return resp.data as ProviderRequestsSummaryItemDTO[];
    }

    statisticIssuanceTime = async (request: Object): Promise<IssuanceTimeStatItemDTO[]> => {
        let resp = await axios({
            url: `/statistic/issuance-time`,
            method: 'GET',
            params: {
                ...request
            },
            paramsSerializer: params => {
                return qs.stringify(params)
            }
        });

        return resp.data as IssuanceTimeStatItemDTO[];
    }

    statisticCascadeRatingSnapshots = async (request: Object): Promise<PaginatedResponseDTO<CascadeRatingSnapshotDTO>> => {
        let resp = await axios({
            url: `/statistic/cascade-rating-snapshots`,
            method: 'GET',
            params: {
                ...request
            },
            paramsSerializer: params => {
                return qs.stringify(params)
            }
        });

        return resp.data as PaginatedResponseDTO<CascadeRatingSnapshotDTO>;
    }

    deals = async (pagination: PaginationDTO, orderByDTO: OrderByDTO = {field: 'createdAt', direction: 'desc'} as OrderByDTO, request: DealRequestDTO): Promise<PaginatedResponseDTO<ExtendedDealDTO>> => {
        let orderBy = {} as any
        if (orderByDTO.field) {
            orderBy[orderByDTO.field] = orderByDTO.direction
        }
        let resp = await axios({
            url: `/trader-deals`,
            method: 'GET',
            params: {
                limit: pagination.limit,
                offset: pagination.offset,
                orderBy: orderBy,
                ...request
            },
            paramsSerializer: params => {
                return qs.stringify(params)
            }
        });

        return resp.data as PaginatedResponseDTO<ExtendedDealDTO>;
    }

    dealHistory = async (dealId: string, pagination: PaginationDTO): Promise<PaginatedResponseDTO<DealHistoryDTO>> => {
        let resp = await axios({
            url: `/trader-deals/${dealId}/history`,
            method: 'GET',
            params: {
                limit: pagination.limit,
                offset: pagination.offset,
            },
        });

        return resp.data as PaginatedResponseDTO<DealHistoryDTO>;
    }

    deal = async (id: string): Promise<TraderDealDTO> => {
        let resp = await axios({
            url: `/trader-deals/${id}`,
            method: 'GET',
        });

        return resp.data as TraderDealDTO;
    }

    dealManualSbpQrLink = async (
        dealId: string,
        payload: { image: string } | { link: string },
    ): Promise<TraderDealDTO> => {
        let resp = await axios({
            url: `/trader-deals/${dealId}/manual-sbp-qr-link`,
            method: 'PUT',
            data: payload,
        });

        return resp.data as TraderDealDTO;
    }

    dealClientCard = async (dealId: string): Promise<ClientCardDTO> => {
        let resp = await axios({
            url: `/trader-deals/${dealId}/client-card`,
            method: 'GET',
        });

        return resp.data as ClientCardDTO;
    }

    dealQrCodeBlob = async (dealId: string): Promise<Blob> => {
        const resp = await axios({
            url: `/qr-code/${dealId}`,
            method: 'GET',
            responseType: 'blob',
        });

        return resp.data as Blob;
    }

    dealSendWebhook = async (id: string, status: DealStatus|null = null): Promise<void> => {
        let resp = await axios({
            url: status ? `/trader-deals/${id}/webhook/${status}` : `/trader-deals/${id}/webhook`,
            method: 'POST',
        });
    }

    dealAssignTrader = async (id: string, traderId: number): Promise<void> => {
        let resp = await axios({
            url: `/trader-deals/${id}/assign`,
            method: 'PUT',
            data: {
                traderId: traderId
            }
        });
    }

    assignTraderByUnassignedDeal = async (id: string, traderId: number): Promise<void> => {
        let resp = await axios({
            url: `/trader-deals/${id}/assign-by-unassigned`,
            method: 'PUT',
            data: {
                traderId: traderId
            }
        });
    }

    payOutSupportedMethodsSources = async (): Promise<string[]> => {
        let resp = await axios({
            url: `/trader-deals/pay-out/supported-methods-sources`,
            method: 'GET',
        });

        return resp.data as string[];
    }

    payOutDocLink = async (): Promise<string> => {
        let resp = await axios({
            url: `/trader-deals/pay-out/doc-link`,
            method: 'GET',
        });

        return resp.data as string;
    }

    attachmentsUpload = async (file: File): Promise<AttachmentDTO> => {
        const formData = new FormData();
        formData.append('file', file)

        let resp = await axios({
            url: `/attachments`,
            data: formData,
            method: 'POST',
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });

        return resp.data as AttachmentDTO;
    }

    receiptVerification = async (file: File, fields: {paymentMethod: string, requisite: string, bankName: string, amount: string}|null = null): Promise<any> => {
        const formData = new FormData();
        formData.append('file', file)
        if (fields !== null) {
            formData.append('paymentMethod', fields.paymentMethod)
            formData.append('requisite', fields.requisite)
            formData.append('bankName', fields.bankName)
            formData.append('amount', fields.amount)
        }

        let resp = await axios({
            url: `/receipt-verification`,
            data: formData,
            method: 'POST',
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });

        return resp.data as any;
    }

    dealChangeStatus = async (id: string, action: string, req: Object = {}): Promise<TraderDealDTO> => {
        let resp = await axios({
            url: `/trader-deals/${id}/${action}`,
            data: {
                ...req
            },
            method: 'PUT',
        });

        return resp.data as TraderDealDTO;
    }

    dealDisputeAutocompleting = async (id: string, action: string, form: any = {}): Promise<TraderDealDTO> => {
        let resp = await axios({
            url: `/trader-deals/${id}/dispute-autocompleting/${action}`,
            method: 'PUT',
            data: form
        });

        return resp.data as TraderDealDTO;
    }

    dealsCount = async (request: DealRequestDTO): Promise<number> => {
        let resp = await axios({
            url: `/trader-deals/count`,
            method: 'GET',
            params: {
                ...request
            },
            paramsSerializer: params => {
                return qs.stringify(params)
            }
        });

        return resp.data as number;
    }

    paymentMethods = async (): Promise<PaymentMethodsDTO[]> =>  {
        let resp = await axios({
            url: `/payment-methods`,
            method: 'GET',
        })

        return resp.data as PaymentMethodsDTO[];
    }

    rateSources = async (): Promise<string[]> =>  {
        let resp = await axios({
            url: `/rate-sources`,
            method: 'GET',
        })

        return resp.data as string[];
    }

    rateSourcesWithCustom = async (): Promise<RateSourceDTO[]> =>  {
        let resp = await axios({
            url: `/rate-sources`,
            method: 'GET',
            params: { withCustom: 1 },
        })

        return resp.data as RateSourceDTO[];
    }

    rateSourcesAll = async (): Promise<RateSourceDTO[]> =>  {
        let resp = await axios({
            url: `/rate-sources/all`,
            method: 'GET',
        })

        return resp.data as RateSourceDTO[];
    }

    app = async (): Promise<any> =>  {
        let resp = await axios({
            url: `/app`,
            method: 'GET',
        })

        return resp.data as any;
    }

    appsAll = async (): Promise<FrontendAppDTO[]> =>  {
        let resp = await axios({
            url: `/app/all`,
            method: 'GET',
        })

        return resp.data as FrontendAppDTO[];
    }

    paymentOptions = async (): Promise<PaymentOptionsDTO[]> =>  {
        let resp = await axios({
            url: `/payment-methods/options`,
            method: 'GET',
        })

        return resp.data as PaymentOptionsDTO[];
    }

    crossBorderCurrencies = async (): Promise<string[]> =>  {
        let resp = await axios({
            url: `/payment-methods/cross-border-currencies`,
            method: 'GET',
        })

        return resp.data as string[];
    }

    payoutMethods = async (pagination: PaginationDTO, orderBy: Object): Promise<PaginatedResponseDTO<TraderPayoutMethodDTO>> => {
        let resp = await axios({
            url: `/payout-methods`,
            method: 'GET',
            params: {
                limit: pagination.limit,
                offset: pagination.offset,
                orderBy: orderBy,
            },
            paramsSerializer: params => {
                return qs.stringify(params)
            }
        });

        return resp.data as PaginatedResponseDTO<TraderRequisitesDTO>;
    }

    requisites = async (pagination: PaginationDTO, orderBy: Object, request: RequisitesRequestDTO): Promise<PaginatedResponseDTO<TraderRequisitesDTO>> => {
        let resp = await axios({
            url: `/requisites`,
            method: 'GET',
            params: {
                limit: pagination.limit,
                offset: pagination.offset,
                orderBy: orderBy,
                ...request
            },
            paramsSerializer: params => {
                return qs.stringify(params)
            }
        });

        return resp.data as PaginatedResponseDTO<TraderRequisitesDTO>;
    }

    requisitesPhoneGroups = async (pagination: PaginationDTO, request: RequisitesRequestDTO): Promise<PaginatedResponseDTO<RequisitesPhoneGroupDTO>> => {
        let resp = await axios({
            url: `/requisites/group-by-phone`,
            method: 'GET',
            params: {
                limit: pagination.limit,
                offset: pagination.offset,
                ...request
            },
            paramsSerializer: params => {
                return qs.stringify(params)
            }
        });

        return resp.data as PaginatedResponseDTO<RequisitesPhoneGroupDTO>;
    }

    bulkToggleRequisites = async (type: 'enable'|'disable', ids: number[], isAgreeBlacklistPaymentMethod: boolean = false): Promise<BulkToggleRequisitesResponseDTO> => {
        let resp = await axios({
            url: `/requisites/bulk-toggle/${type}`,
            data: {ids, isAgreeBlacklistPaymentMethod},
            method: 'PUT',
        })

        return resp.data as BulkToggleRequisitesResponseDTO
    }

    bulkUpdateRequisites = async (ids: number[], changes: Record<string, any>, isAgreeBlacklistPaymentMethod: boolean = false): Promise<BulkUpdateRequisitesResponseDTO> => {
        let resp = await axios({
            url: `/requisites/bulk-update`,
            data: {ids, changes, isAgreeBlacklistPaymentMethod},
            method: 'PUT',
        })

        return resp.data as BulkUpdateRequisitesResponseDTO
    }

    reuseMinCaps = async (): Promise<ReuseMinCapsDTO> => {
        let resp = await axios({
            url: `/requisites/reuse-min-caps`,
            method: 'GET',
        })

        return resp.data as ReuseMinCapsDTO
    }

    pendingPaymentRequestsCount = async (): Promise<PendingPaymentRequestsCountDTO> => {
        let resp = await axios({
            url: `/payment-requests/pending-count`,
            method: 'GET',
        });

        return resp.data as PendingPaymentRequestsCountDTO;
    }

    withdrawals = async (pagination: PaginationDTO, requestDTO: any = {}): Promise<PaginatedResponseDTO<WithdrawalDTO>> => {
        let resp = await axios({
            url: `/withdrawals`,
            method: 'GET',
            params: {
                limit: pagination.limit,
                offset: pagination.offset,
                ...requestDTO
            },
            paramsSerializer: params => {
                return qs.stringify(params)
            }
        });

        return resp.data as PaginatedResponseDTO<WithdrawalDTO>;
    }

    withdrawalsExport = async (requestDTO: any = {}): Promise<Blob> => {
        let resp = await axios({
            url: `/withdrawals/export`,
            method: 'GET',
            params: requestDTO,
            responseType: 'blob',
            paramsSerializer: params => {
                return qs.stringify(params)
            }
        });

        return resp.data as Blob;
    }

    searchDeposit = async (requestDTO: { trx: string }): Promise<any> => {
        let resp = await axios({
            url: `/deposits/search`,
            method: 'POST',
            data: requestDTO,
        });

        return resp.data;
    }

    creditDeposit = async (requestDTO: { trx: string }): Promise<any> => {
        let resp = await axios({
            url: `/deposits/credit`,
            method: 'POST',
            data: requestDTO,
        });

        return resp.data;
    }

    withdrawalsFee= async (): Promise<MoneyDTO> => {
        let resp = await axios({
            url: `/withdrawals/fee`,
            method: 'GET',
        });

        return resp.data as MoneyDTO;
    }

    withdrawalsSettlementForAccount= async (id: string): Promise<any> => {
        let resp = await axios({
            url: `/withdrawals/settlement-for-account/${id}`,
            method: 'GET',
        });

        return resp.data as any;
    }

    accountOperations = async (pagination: PaginationDTO, orderBy: Object, request: Object): Promise<PaginatedResponseDTO<AccountOperationDTO>> => {
        let resp = await axios({
            url: `/account-operations`,
            method: 'GET',
            params: {
                limit: pagination.limit,
                offset: pagination.offset,
                orderBy: orderBy,
                ...request

            },
            paramsSerializer: params => {
                return qs.stringify(params)
            }
        });

        return resp.data as PaginatedResponseDTO<AccountOperationDTO>;
    }

    accountOperationsExport = async (requestDTO: any = {}): Promise<Blob> => {
        let resp = await axios({
            url: `/account-operations/export`,
            method: 'GET',
            params: requestDTO,
            responseType: 'blob',
            paramsSerializer: params => {
                return qs.stringify(params)
            }
        });

        return resp.data as Blob;
    }

    invoices = async (pagination: PaginationDTO, orderBy: Object, request: Object = {}): Promise<PaginatedResponseDTO<InvoiceDTO>> => {
        let resp = await axios({
            url: `/invoices`,
            method: 'GET',
            params: {
                limit: pagination.limit,
                offset: pagination.offset,
                orderBy: orderBy,
                ...request
            },
            paramsSerializer: params => {
                return qs.stringify(params)
            }
        });

        return resp.data as PaginatedResponseDTO<InvoiceDTO>;
    }

    updateRequisites = async (id: number, requestDTO: RequisitesUpdateRequestDTO): Promise<TraderRequisitesDTO> => {
        let resp = await axios({
            url: `/requisites/${id}`,
            data: requestDTO,
            method: 'PUT',
        })

        return resp.data as TraderRequisitesDTO
    }

    updateRequisitesPayInDealSums = async (id: number, requestDTO: object): Promise<TraderRequisitesDTO> => {
        let resp = await axios({
            url: `/requisites/${id}/pay-in-deal-sums`,
            data: requestDTO,
            method: 'PUT',
        })

        return resp.data as TraderRequisitesDTO
    }

    resetRequisitesLimits = async (id: number, type: 'day' | 'month' | 'total'): Promise<TraderRequisitesDTO> => {
        let resp = await axios({
            url: `/requisites/${id}/reset-day-limits?type=${type}`,
            method: 'POST',
        })

        return resp.data as TraderRequisitesDTO
    }

    payoutMethodsCreate = async (requestDTO: PayoutMethodUpdateRequestDTO): Promise<TraderPayoutMethodDTO> => {
        let resp = await axios({
            url: `/payout-methods`,
            data: requestDTO,
            method: 'POST',
        })

        return resp.data as TraderRequisitesDTO
    }

    payoutMethodsUpdate = async (id: number, requestDTO: PayoutMethodUpdateRequestDTO): Promise<TraderPayoutMethodDTO> => {
        let resp = await axios({
            url: `/payout-methods/${id}`,
            data: requestDTO,
            method: 'PUT',
        })

        return resp.data as TraderPayoutMethodDTO
    }

    togglePayoutMethodActivity = async (id: number, type: string): Promise<TraderPayoutMethodDTO> => {
        let resp = await axios({
            url: `/payout-methods/${id}/${type}`,
            method: 'PUT',
        })

        return resp.data as TraderRequisitesDTO
    }

    toggleRequisitesActivity = async (id: number, type: string, data:any = {}): Promise<TraderRequisitesDTO> => {
        let resp = await axios({
            url: `/requisites/${id}/${type}`,
            data: data,
            method: 'PUT',
        })

        return resp.data as TraderRequisitesDTO
    }

    tradersCreate = async (requestDTO: TradersCreateRequestDTO): Promise<TraderDTO> => {
        let resp = await axios({
            url: `/traders`,
            data: requestDTO,
            method: 'POST',
        })

        return resp.data as TraderDTO
    }

    accountWithdrawalCreate = async (id: string, requestDTO: AccountWithdrawalRequestDTO): Promise<WithdrawalDTO> => {
        let resp = await axios({
            url: `/accounts/${id}/withdraw`,
            data: requestDTO,
            method: 'POST',
        })

        return resp.data as WithdrawalDTO
    }

    accountTransferCreate = async (id: string, requestDTO: AccountTransferRequestDTO): Promise<void> => {
        let resp = await axios({
            url: `/accounts/${id}/transfer`,
            data: requestDTO,
            method: 'POST',
        })
    }

    tradersUpdate = async (id: number, requestDTO: TradersUpdateRequestDTO): Promise<TraderDTO> => {
        let resp = await axios({
            url: `/traders/${id}`,
            data: requestDTO,
            method: 'PUT',
        })

        return resp.data as TraderDTO
    }

    tradersChangePassword = async (id: number, plainPassword: string): Promise<void> => {
        (await axios({
            url: `/traders/${id}/password`,
            method: 'PUT',
            data: {plainPassword},
        })).data
    }

    tradersToggleTraffic = async (id: number, direction: Direction, status: string): Promise<TraderDTO> => {
        let resp = await axios({
            url: `/traders/${id}/${direction}/${status}`,
            method: 'PUT',
        })

        return resp.data as TraderDTO
    }

    deviceToggleBlock = async (id: string,  status: string): Promise<TraderDeviceDTO> => {
        let resp = await axios({
            url: `/trader-devices/${id}/${status}`,
            method: 'PUT',
        })

        return resp.data as TraderDeviceDTO
    }

    usersCreate = async (requestDTO: UserCreateRequestDTO): Promise<UserDTO> => {
        let resp = await axios({
            url: `/users`,
            data: requestDTO,
            method: 'POST',
        })

        return resp.data as UserDTO
    }

    usersUpdate = async (id: number, requestDTO: UserUpdateRequestDTO): Promise<UserDTO> => {
        let resp = await axios({
            url: `/users/${id}`,
            data: requestDTO,
            method: 'PUT',
        })

        return resp.data as UserDTO
    }

    merchantOperatorCreate = async (requestDTO: MerchantOperatorCreateRequestDTO): Promise<MerchantOperatorDTO> => {
        let resp = await axios({
            url: `/merchant-operators`,
            data: requestDTO,
            method: 'POST',
        })

        return resp.data as MerchantOperatorDTO
    }

    merchantOperatorUpdate = async (id: number, requestDTO: MerchantOperatorUpdateRequestDTO): Promise<MerchantOperatorDTO> => {
        let resp = await axios({
            url: `/merchant-operators/${id}`,
            data: requestDTO,
            method: 'PUT',
        })

        return resp.data as MerchantOperatorDTO
    }

    merchantsCreate = async (requestDTO: MerchantCreateRequestDTO): Promise<MerchantDTO> => {
        let resp = await axios({
            url: `/merchants`,
            data: requestDTO,
            method: 'POST',
        })

        return resp.data as MerchantDTO
    }

    merchantsUpdate = async (id: number, requestDTO: MerchantUpdateRequestDTO): Promise<MerchantDTO> => {
        let resp = await axios({
            url: `/merchants/${id}`,
            data: requestDTO,
            method: 'PUT',
        })

        return resp.data as MerchantDTO
    }

    merchantsChangePassword = async (id: number, plainPassword: string): Promise<void> => {
        (await axios({
            url: `/merchants/${id}/password`,
            method: 'PUT',
            data: {plainPassword},
        })).data
    }

    merchantSettingsHistory = async (merchantId: number, pagination: PaginationDTO): Promise<PaginatedResponseDTO<SettingsHistoryItemDTO>> => {
        let resp = await axios({
            url: `/merchants/${merchantId}/settings-history`,
            method: 'GET',
            params: {
                limit: pagination.limit,
                offset: pagination.offset,
            },
        });

        return resp.data as PaginatedResponseDTO<SettingsHistoryItemDTO>
    }

    storeSettingsHistory = async (
        storeId: number,
        pagination: PaginationDTO,
    ): Promise<PaginatedResponseDTO<StoreSettingsHistoryItemDTO>> => {
        let resp = await axios({
            url: `/stores/${storeId}/settings-history`,
            method: 'GET',
            params: {
                limit: pagination.limit,
                offset: pagination.offset,
            },
        });

        return resp.data as PaginatedResponseDTO<StoreSettingsHistoryItemDTO>
    }

    storeCrossBorderSettingsHistory = async (
        storeId: number,
        pagination: PaginationDTO,
    ): Promise<PaginatedResponseDTO<StoreSettingsHistoryItemDTO>> => {
        let resp = await axios({
            url: `/stores/${storeId}/cross-border-settings-history`,
            method: 'GET',
            params: {
                limit: pagination.limit,
                offset: pagination.offset,
            },
        });

        return resp.data as PaginatedResponseDTO<StoreSettingsHistoryItemDTO>
    }

    traderHistory = async (traderId: number, pagination: PaginationDTO): Promise<PaginatedResponseDTO<SettingsHistoryItemDTO>> => {
        let resp = await axios({
            url: `/traders/${traderId}/history`,
            method: 'GET',
            params: {
                limit: pagination.limit,
                offset: pagination.offset,
            },
        });

        return resp.data as PaginatedResponseDTO<SettingsHistoryItemDTO>
    }

    deletePayoutMethod = async (id: number): Promise<void> => {
        await axios({
            url: `/payout-methods/${id}`,
            method: 'DELETE',
        })
    }

    deleteRequisites = async (id: number): Promise<void> => {
        await axios({
            url: `/requisites/${id}`,
            method: 'DELETE',
        })
    }

    requisitesActionHistory = async (requisitesId: number, pagination: PaginationDTO): Promise<PaginatedResponseDTO<RequisitesActionHistoryDTO>> => {
        let resp = await axios({
            url: `/requisites/${requisitesId}/action-history`,
            method: 'GET',
            params: {
                limit: pagination.limit,
                offset: pagination.offset,
            },
        });

        return resp.data as PaginatedResponseDTO<RequisitesActionHistoryDTO>;
    }

    requisitesCounterparties = async (requisitesId: number, storeId?: number): Promise<CounterpartyStatisticsDTO[]> => {
        let resp = await axios({
            url: `/requisites/${requisitesId}/counterparties`,
            method: 'GET',
            params: storeId != null ? {storeId} : undefined,
        });

        return resp.data as CounterpartyStatisticsDTO[];
    }

    attachRequisitesCounterparty = async (requisitesId: number, body: { storeId: number; userId: string }): Promise<CounterpartyImportResultDTO> => {
        let resp = await axios({
            url: `/requisites/${requisitesId}/counterparties`,
            method: 'POST',
            data: body,
        });

        return resp.data as CounterpartyImportResultDTO;
    }

    deleteRequisitesCounterparty = async (requisitesId: number, userId: string, storeId?: number): Promise<void> => {
        await axios({
            url: `/requisites/${requisitesId}/counterparties/${userId}`,
            method: 'DELETE',
            params: storeId != null ? {storeId} : undefined,
        });
    }

    getAvailableRequisitesForReattach = async (requisitesId: number, userId: string): Promise<TraderRequisitesDTO[]> => {
        let resp = await axios({
            url: `/requisites/${requisitesId}/counterparties/${userId}/available-requisites`,
            method: 'GET',
        });

        return resp.data as TraderRequisitesDTO[];
    }

    reattachCounterparty = async (requisitesId: number, userId: string, newTraderRequisitesId: number): Promise<void> => {
        await axios({
            url: `/requisites/${requisitesId}/counterparties/${userId}/reattach`,
            method: 'PUT',
            data: {
                newTraderRequisitesId: newTraderRequisitesId
            }
        });
    }

    requisitesCounterpartyBan = async (requisitesId: number, userId: string, body: RequisiteCounterpartyBanRequestDTO): Promise<void> => {
        await axios({
            url: `/requisites/${requisitesId}/counterparties/${userId}/ban`,
            method: 'POST',
            data: body,
        });
    }

    validateRequisitesCounterpartiesImport = async (requisitesId: number, storeId: number, file: File): Promise<CounterpartyImportResultDTO> => {
        const formData = new FormData();
        formData.append('storeId', String(storeId));
        formData.append('file', file);

        let resp = await axios({
            url: `/requisites/${requisitesId}/counterparties/import/validate`,
            data: formData,
            method: 'POST',
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });

        return resp.data as CounterpartyImportResultDTO;
    }

    importRequisitesCounterparties = async (requisitesId: number, storeId: number, file: File): Promise<CounterpartyImportResultDTO> => {
        const formData = new FormData();
        formData.append('storeId', String(storeId));
        formData.append('file', file);

        let resp = await axios({
            url: `/requisites/${requisitesId}/counterparties/import`,
            data: formData,
            method: 'POST',
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });

        return resp.data as CounterpartyImportResultDTO;
    }

    validateStoreCounterpartiesImport = async (storeId: number, file: File): Promise<CounterpartyImportResultDTO> => {
        const formData = new FormData();
        formData.append('file', file);

        let resp = await axios({
            url: `/stores/${storeId}/counterparties/import/validate`,
            data: formData,
            method: 'POST',
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });

        return resp.data as CounterpartyImportResultDTO;
    }

    importStoreCounterparties = async (storeId: number, file: File): Promise<CounterpartyImportResultDTO> => {
        const formData = new FormData();
        formData.append('file', file);

        let resp = await axios({
            url: `/stores/${storeId}/counterparties/import`,
            data: formData,
            method: 'POST',
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });

        return resp.data as CounterpartyImportResultDTO;
    }

    createRequisites = async (requestDTO: RequisitesUpdateRequestDTO): Promise<TraderRequisitesDTO> => {
        let resp = await axios({
            url: `/requisites`,
            data: requestDTO,
            method: 'POST',
        })

        return resp.data as TraderRequisitesDTO
    }

    importRequisites = async (requestDTO: BulkRequisitesUploadRequestDTO): Promise<any> => {
        let resp = await axios({
            url: `/requisites/bulk-requisites`,
            data: requestDTO,
            method: 'POST',
        });

        return resp.data as any
    }

    deleteAllRequisites = async (requestDTO: any): Promise<any> => {
        let resp = await axios({
            url: `/requisites/bulk-delete`,
            data: requestDTO,
            method: 'DELETE',
        });

        return resp.data as any
    }

    toggleStatusAllRequisites = async (status: string, requestDTO: any): Promise<any> => {
        let resp = await axios({
            url: `/requisites/bulk-active/${status}`,
            data: requestDTO,
            method: 'PUT',
        });

        return resp.data as any
    }

    reorderRequisites = async (ids: number[]): Promise<void> => {
        await axios({
            url: `/requisites/reorder`,
            data: {ids},
            method: 'PUT',
        });
    }

    createInvoice = async (requestDTO: Object): Promise<InvoiceDTO> => {
        let resp = await axios({
            url: `/invoices`,
            data: requestDTO,
            method: 'POST',
        })

        return resp.data as InvoiceDTO
    }

    tokenGet = async (credentials: any): Promise<AccessTokenDTO> => {
        const headers: any = {
            'Authorization': ''
        }
        if (credentials.captchaToken) {
            headers['X-CAPTCHA-TOKEN'] = credentials.captchaToken
        }

        let resp = await axios({
            url: `/token/get`,
            data: {
                username: credentials.username,
                password: credentials.password,
            },
            method: 'POST',
            headers,
        })

        return resp.data as AccessTokenDTO
    }

    systemSettings = async (): Promise<SystemSettingsDTO[]> => {
        let resp = await axios({
            url: `/system-settings/all`,
            method: 'GET',
        })

        return resp.data as SystemSettingsDTO[];
    }

    updateSystemSettings = async (id: string, requestDTO: SystemSettingsUpdateRequestDTO): Promise<SystemSettingsDTO> => {
        let resp = await axios({
            url: `/system-settings/${id}`,
            data: requestDTO,
            method: 'PUT',
        })

        return resp.data as SystemSettingsDTO
    }

    paymentInstructions = async (pagination: PaginationDTO): Promise<PaginatedResponseDTO<PaymentInstructionDTO>> => {
        let resp = await axios({
            url: `/payment-instructions`,
            method: 'GET',
            params: {
                limit: pagination.limit,
                offset: pagination.offset,
            }
        })

        return resp.data as PaginatedResponseDTO<PaymentInstructionDTO>;
    }

    paymentInstructionCreate = async (requestDTO: PaymentInstructionRequestDTO): Promise<PaymentInstructionDTO> => {
        let resp = await axios({
            url: `/payment-instructions`,
            data: requestDTO,
            method: 'POST',
        })

        return resp.data as PaymentInstructionDTO
    }

    paymentInstructionUpdate = async (id: string, requestDTO: PaymentInstructionRequestDTO): Promise<PaymentInstructionDTO> => {
        let resp = await axios({
            url: `/payment-instructions/${id}`,
            data: requestDTO,
            method: 'PUT',
        })

        return resp.data as PaymentInstructionDTO
    }

    paymentInstructionDelete = async (id: string): Promise<void> => {
        await axios({
            url: `/payment-instructions/${id}`,
            method: 'DELETE',
        })
    }

    paymentPageLayouts = async (): Promise<PaymentPageLayoutDTO[]> => {
        let resp = await axios({
            url: `/payment-page-layouts`,
            method: 'GET',
        })

        return resp.data as PaymentPageLayoutDTO[]
    }

    paymentMethodBlackList = async (): Promise<string[]>=> {
        let resp = await axios({
            url: `/payment-methods/blacklist`,
            method: 'GET',
        })

        return resp.data as string[];
    }

    processIncome = async (id: number): Promise<void> => {
        let resp = await axios({
            url: `/partner-income/${id}/accrual`,
            method: 'POST',
        });
    }

    partners = async (): Promise<any[]> => {
        let resp = await axios({
            url: `/partners`,
            method: 'GET',
        });

        return resp.data as any[]
    }

    merchantRequestLogs = async (invoiceId: string, pagination: PaginationDTO): Promise<PaginatedResponseDTO<any>> => {
        let resp = await axios({
            url: `/merchant-request-logs`,
            method: 'GET',
            params: {
                invoiceId,
                limit: pagination.limit,
                offset: pagination.offset,
            }
        });

        return resp.data as PaginatedResponseDTO<any>;
    }

    webhooksInvoice = async (invoiceId: string): Promise<WebhookDTO[]> => {
        let resp = await axios({
            url: `/webhooks/invoice/${invoiceId}`,
            method: 'GET',
        });

        return resp.data;
    }

    traderRequisitesSettings = async (): Promise<TraderRequisitesSettingDTO[]> => {
        let resp = await axios({
            url: `/trader-requisites-settings`,
            method: 'GET',
        });

        return resp.data;
    }

    createTraderRequisitesSettings = async (data: TraderRequisitesSettingCreateRequestDTO): Promise<TraderRequisitesSettingDTO> => {
        let resp = await axios({
            url: `/trader-requisites-settings`,
            method: 'POST',
            data: data
        });

        return resp.data;
    }

    updateTraderRequisitesSettings = async (data: TraderRequisitesSettingUpdateRequestDTO): Promise<TraderRequisitesSettingDTO> => {
        let resp = await axios({
            url: `/trader-requisites-settings`,
            method: 'PUT',
            data: data
        });

        return resp.data;
    }

    toggleAllTraderLimits = async (data: TraderRequisitesSettingToggleRequestDTO): Promise<{message: string}> => {
        let resp = await axios({
            url: `/trader-requisites-settings/toggle-all-limits`,
            method: 'POST',
            data: data
        });

        return resp.data;
    }

    getTraderPlans = async (traderId: number): Promise<TraderPlanDTO[]> => {
        let resp = await axios({
            url: `/trader-requisites-settings/trader/${traderId}/plans`,
            method: 'GET'
        });

        return resp.data;
    }

    checkFraudexRequisite = async (requisite: string): Promise<FraudexCheckResponseDTO> => {
        let resp = await axios({
            url: `/requisites/fraudex-check`,
            method: 'POST',
            data: {
                requisite
            }
        });

        return resp.data as FraudexCheckResponseDTO;
    }

    sendFraudexFeedback = async (requisiteId: number, text: string): Promise<void> => {
        await axios({
            url: `/requisites/${requisiteId}/fraudex-feedback`,
            method: 'POST',
            data: {
                text
            }
        });
    }

    telegramBroadcastAudiences = async (): Promise<TelegramBroadcastAudienceDTO[]> => {
        const resp = await axios({
            url: `/telegram-broadcast-audiences`,
            method: 'GET',
        });
        return resp.data as TelegramBroadcastAudienceDTO[];
    }

    telegramBroadcastAudienceCreate = async (name: string, spec: TelegramBroadcastAudienceSpec): Promise<TelegramBroadcastAudienceDTO> => {
        const resp = await axios({
            url: `/telegram-broadcast-audiences`,
            method: 'POST',
            data: {name, spec},
        });
        return resp.data as TelegramBroadcastAudienceDTO;
    }

    telegramBroadcastAudienceUpdate = async (id: number, name: string, spec: TelegramBroadcastAudienceSpec): Promise<TelegramBroadcastAudienceDTO> => {
        const resp = await axios({
            url: `/telegram-broadcast-audiences/${id}`,
            method: 'PUT',
            data: {name, spec},
        });
        return resp.data as TelegramBroadcastAudienceDTO;
    }

    telegramBroadcastAudienceDelete = async (id: number): Promise<void> => {
        await axios({
            url: `/telegram-broadcast-audiences/${id}`,
            method: 'DELETE',
        });
    }

    telegramBroadcastMerchantGroups = async (query: string): Promise<TelegramBroadcastMerchantGroupDTO[]> => {
        const resp = await axios({
            url: `/telegram-broadcast-audiences/merchant-groups`,
            method: 'GET',
            params: {query},
        });
        return resp.data as TelegramBroadcastMerchantGroupDTO[];
    }

    telegramBroadcastPreview = async (payload: { audienceId?: number; spec?: TelegramBroadcastAudienceSpec }): Promise<{ chatCount: number }> => {
        const resp = await axios({
            url: `/telegram-broadcasts/preview`,
            method: 'POST',
            data: payload,
        });
        return resp.data as { chatCount: number };
    }

    telegramBroadcastSend = async (payload: { audienceId?: number; spec?: TelegramBroadcastAudienceSpec; text: string }): Promise<{ id: number; chatCount: number }> => {
        const resp = await axios({
            url: `/telegram-broadcasts`,
            method: 'POST',
            data: payload,
        });
        return resp.data as { id: number; chatCount: number };
    }

    telegramBroadcasts = async (pagination: PaginationDTO): Promise<PaginatedResponseDTO<TelegramBroadcastJournalItemDTO>> => {
        const resp = await axios({
            url: `/telegram-broadcasts`,
            method: 'GET',
            params: {
                limit: pagination.limit,
                offset: pagination.offset,
            },
        });
        return resp.data as PaginatedResponseDTO<TelegramBroadcastJournalItemDTO>;
    }
}

export const api = new APIClient();